module.exports = __webpack_public_path__ + "img/111.77064122.jpg";